/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCatalogDefinitions } from 'app/entities/catalog-definitions/catalog-definitions.reducer';
import { createEntity, getEntity, reset, updateEntity } from './medicine.reducer';

export const MedicineUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const catalogDefinitions = useAppSelector(state => state.catalogDefinitions.entities);
  const medicineEntity = useAppSelector(state => state.medicine.entity);
  const loading = useAppSelector(state => state.medicine.loading);
  const updating = useAppSelector(state => state.medicine.updating);
  const updateSuccess = useAppSelector(state => state.medicine.updateSuccess);

  const handleClose = () => {
    navigate(`/medicine${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCatalogDefinitions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...medicineEntity,
      ...values,
      catalog: catalogDefinitions.find(it => it.id.toString() === values.catalog?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...medicineEntity,
          catalog: medicineEntity?.catalog?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.medicine.home.createOrEditLabel" data-cy="MedicineCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.medicine.home.createOrEditLabel">Create or edit a Medicine</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="medicine-id"
                  label={translate('tinyMedicRestApp.medicine.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.name')}
                id="medicine-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 1000, message: translate('entity.validation.maxlength', { max: 1000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.tmContains')}
                id="medicine-tmContains"
                name="tmContains"
                data-cy="tmContains"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.usedFor')}
                id="medicine-usedFor"
                name="usedFor"
                data-cy="usedFor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.tmType')}
                id="medicine-tmType"
                name="tmType"
                data-cy="tmType"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.addedBy')}
                id="medicine-addedBy"
                name="addedBy"
                data-cy="addedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.timestampentry')}
                id="medicine-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.active')}
                id="medicine-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.lastupdated')}
                id="medicine-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.manufacturer')}
                id="medicine-manufacturer"
                name="manufacturer"
                data-cy="manufacturer"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.genericName')}
                id="medicine-genericName"
                name="genericName"
                data-cy="genericName"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.unit')}
                id="medicine-unit"
                name="unit"
                data-cy="unit"
                type="text"
                validate={{
                  maxLength: { value: 1000, message: translate('entity.validation.maxlength', { max: 1000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.quantity')}
                id="medicine-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  maxLength: { value: 1000, message: translate('entity.validation.maxlength', { max: 1000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.price')}
                id="medicine-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  maxLength: { value: 1000, message: translate('entity.validation.maxlength', { max: 1000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.cursor')}
                id="medicine-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.microSec')}
                id="medicine-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.country')}
                id="medicine-country"
                name="country"
                data-cy="country"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.maximumDailyDose')}
                id="medicine-maximumDailyDose"
                name="maximumDailyDose"
                data-cy="maximumDailyDose"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.minimumDailyDose')}
                id="medicine-minimumDailyDose"
                name="minimumDailyDose"
                data-cy="minimumDailyDose"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicine.schedule')}
                id="medicine-schedule"
                name="schedule"
                data-cy="schedule"
                type="text"
              />
              <ValidatedField
                id="medicine-catalog"
                name="catalog"
                data-cy="catalog"
                label={translate('tinyMedicRestApp.medicine.catalog')}
                type="select"
              >
                <option value="" key="0" />
                {catalogDefinitions
                  ? catalogDefinitions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/medicine" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MedicineUpdate;
